(() => {
  const storageKey = 'relin-recently-viewed-v2';
  const maxItems = 4;
  const maxStoredItems = maxItems + 1;

  const safeUrl = (value) => {
    if (!value) return '';
    if (value.startsWith('/')) return value;
    try {
      const parsed = new URL(value, window.location.origin);
      return parsed.origin === window.location.origin ? `${parsed.pathname}${parsed.search}` : '';
    } catch {
      return '';
    }
  };

  const normalizeItems = (items) => {
    const seenHandles = new Set();
    return items.filter((item) => {
      const handle = typeof item?.handle === 'string' ? item.handle.trim() : '';
      const title = typeof item?.title === 'string' ? item.title.trim() : '';
      const url = safeUrl(item?.url);
      if (!handle || !title || !url || seenHandles.has(handle)) return false;
      seenHandles.add(handle);
      return true;
    });
  };

  const readItems = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(parsed) ? normalizeItems(parsed) : [];
    } catch {
      return [];
    }
  };

  const writeItems = (items) => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(normalizeItems(items).slice(0, maxStoredItems)));
    } catch {
      // Private browsing or storage restrictions should not affect the PDP.
    }
  };

  const render = () => {
    const section = document.querySelector('[data-relin-recently-viewed]');
    const list = section?.querySelector('[data-relin-recently-viewed-list]');
    if (!section || !list) return;

    const currentHandle = document.querySelector('[data-relin-product-view]')?.dataset.handle || '';
    const items = readItems().filter((item) => item.handle !== currentHandle).slice(0, maxItems);
    if (!items.length) {
      section.hidden = true;
      return;
    }

    list.replaceChildren();
    items.forEach((item) => {
      const url = safeUrl(item.url);
      if (!url || !item.title) return;

      const listItem = document.createElement('li');
      listItem.className = 'relin-recently-viewed__item';

      const card = document.createElement('article');
      card.className = 'relin-recent-card';

      const mediaLink = document.createElement('a');
      mediaLink.className = 'relin-recent-card__media';
      mediaLink.href = url;
      mediaLink.setAttribute('aria-label', item.title);

      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image.startsWith('//') ? `https:${item.image}` : item.image;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 533;
        image.height = 533;
        mediaLink.append(image);
      }

      const information = document.createElement('div');
      information.className = 'relin-recent-card__information';

      const title = document.createElement('a');
      title.className = 'relin-recent-card__title';
      title.href = url;
      title.textContent = item.title;
      information.append(title);

      if (item.price) {
        const price = document.createElement('p');
        price.className = 'relin-recent-card__price';
        price.textContent = item.price;
        if (item.compareAt && item.compareAt !== item.price) {
          const compareAt = document.createElement('s');
          compareAt.className = 'relin-recent-card__compare-at';
          compareAt.textContent = item.compareAt;
          price.append(' ', compareAt);
        }
        information.append(price);
      }

      card.append(mediaLink, information);
      listItem.append(card);
      list.append(listItem);
    });

    section.hidden = list.children.length === 0;
  };

  const currentProduct = document.querySelector('[data-relin-product-view]');
  if (currentProduct?.dataset.handle) {
    const current = {
      handle: currentProduct.dataset.handle,
      title: currentProduct.dataset.title || '',
      url: safeUrl(currentProduct.dataset.url || ''),
      image: currentProduct.dataset.image || '',
      price: currentProduct.dataset.price || '',
      compareAt: currentProduct.dataset.compareAt || '',
    };
    writeItems([current, ...readItems().filter((item) => item.handle !== current.handle)]);
  }

  render();
})();
